export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  return new Intl.NumberFormat().format(value);
};
export const getTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};
export const updatePrices = (products) => {
  const latestPrices = {};

  products.forEach((item) => {
    const sku = item.product.sku;
    if (
      !latestPrices[sku] ||
      new Date(item.updatedAt) > new Date(latestPrices[sku].updatedAt)
    ) {
      latestPrices[sku] = {
        price: item.price,
        updatedAt: item.updatedAt,
      };
    }
  });
  return products.map((item) => {
    const sku = item.product.sku;
    return {
      ...item,
      price: latestPrices[sku].price,
    };
  });
};

export const calculateTotalSum = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    const totalPrice = parseFloat(order.totalPrice);
    if (!isNaN(totalPrice)) {
      totalSum += totalPrice;
    }
  });
  return totalSum.toFixed(2); // Return the total sum rounded to 2 decimal places
};
export const calculateTotalSumOrderProducts = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    order.orderProducts.forEach((product) => {
      const productTotalPrice = parseFloat(product.totalPrice);
      if (!isNaN(productTotalPrice)) {
        totalSum += productTotalPrice;
      }
    });
  });
  return totalSum.toFixed(2);
};

export const calculateTotalPaid = (orders) => {
  let totalSum = 0;
  orders.forEach((order) => {
    const paid = parseFloat(order.paid);
    if (!isNaN(paid)) {
      totalSum += paid;
    }
  });
  return totalSum.toFixed(2);
};
export const statues = () => {
  return ["Ordered", "Pending", "Ready for Shipment", "Shipped"];
};
export const paymentLists = () => {
  return ["Paid", "Balance"];
};
export const service = () => {
  return {
    countables: ["Number of SKUs", "Number of Users", "Number of Stores"],
    reports: [
      "Activity Report",
      "Inventory Report",
      "Payment Report",
      "Sales Report",
      "Purchase Order Report",
    ],
  };
};
export const checkReportStatuses = (subscriptionServices) => {
  const reportNames = [
    "Activity Report",
    "Sales Report",
    "Payment Report",
    "Inventory Report",
    "Purchase Order Report",
  ];

  const reportStatus = {};
  reportNames.forEach((name) => {
    const service = subscriptionServices.find((s) => s.name === name);
    reportStatus[name] = service?.value === "on";
  });
  return reportStatus;
};
export const permissions = () => {
  return [
    { group: "Inventory", label: "Add Inventory", value: "addProduct" },
    { group: "Inventory", label: "List Inventories", value: "listAllProducts" },
    {
      group: "Inventory",
      label: "Delete Inventory by ID",
      value: "deleteProduct",
    },
    { group: "Inventory", label: "Update Inventory", value: "updateProduct" },
    { group: "Manage Staff", label: "Manage Staff", value: "manageStaff" },
    { group: "Manage Staff", label: "List Staffs", value: "listStaffs" },

    { group: "Sales", label: "Add Sales", value: "addOrder" },
    { group: "Sales", label: "List Sales", value: "viewOrders" },
    {
      group: "Sales",
      label: "Update Sales Status",
      value: "updateOrderStatus",
    },
    { group: "Customer", label: "Add Customer", value: "addCustomer" },
    { group: "Customer", label: "List Customer", value: "viewCustomer" },
    { group: "Customer", label: "Update Customer", value: "updateCustomer" },
    { group: "Customer", label: "Delete Customer", value: "deleteCustomer" },

    {
      group: "General Setting",
      label: "General Setting",
      value: "generalSetting",
    },
    {
      group: "Categories",
      label: "Manage Categories",
      value: "manageCategories",
    },
    { group: "Report", label: "Sales Report", value: "salesReport" },
    { group: "Report", label: "Inventory Report", value: "inventoryReport" },
    { group: "Report", label: "Activity Report", value: "activityReport" },
    { group: "Shipment", label: "Only mnie", value: "onlyMineShipment" },
    { group: "Shipment", label: "View All", value: "viewAllShipment" },
    { group: "PurchaseOrder", label: "Add", value: "addPo" },
    { group: "PurchaseOrder", label: "List ", value: "viewPo" },
    {
      group: "PurchaseOrder",
      label: "Publish",
      value: "publishPo",
    },
  ];
};
export const getActivityRedirectPath = (item) => {
  const isCreateNewOrder = item.activity.includes("Create New Order");
  const isUpdateOrder = item.activity.includes("Update Order");
  const isCreateCustomer = item.activity.includes("Create Customer");
  const isUpdateCustomer = item.activity.includes("Update Customer");

  const isAssignedOrder = item.activity.includes("Assigned Order");
  const isShippment = item.activity.includes("Changed Shipment");

  let redirectPath = null;

  if (isCreateNewOrder || isUpdateOrder) {
    const orderIdMatch = item.activity.match(
      /(?:Create New Order|Update Order)\s+(\d+)/
    );
    if (orderIdMatch) {
      const orderId = orderIdMatch[1];
      redirectPath = `/print/${orderId}`;
    }
  } else if (isAssignedOrder) {
    const orderIdMatch = item.activity.match(/(?:Assigned Order)\s+(\d+)/);
    if (orderIdMatch) {
      const orderId = orderIdMatch[1];
      redirectPath = `/print/${orderId}`;
    }
  } else if (isShippment) {
    const orderIdMatch = item.activity.match(/(?:Changed Shipment)\s+(\d+)/);
    if (orderIdMatch) {
      const orderId = orderIdMatch[1];
      redirectPath = `/shipment/${orderId}`;
    }
  } else if (isCreateCustomer) {
    const customerIdMatch = item.activity.match(
      /Create Customer\s+([0-9a-fA-F-]+)/
    );
    if (customerIdMatch) {
      const customerId = customerIdMatch[1];
      redirectPath = `/customer/order/${customerId}`;
    }
  } else if (isUpdateCustomer) {
    const customerIdMatch = item.activity.match(
      /Update Customer\s+([0-9a-fA-F-]+)/
    );
    if (customerIdMatch) {
      const customerId = customerIdMatch[1];
      redirectPath = `/customer/order/${customerId}`;
    }
  }

  return redirectPath;
};
export const cleanActivityString = (activity) => {
  const uuidRegex =
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  return activity.replace(uuidRegex, "").trim() || "Activity";
};
export const pageSizes = [15, 25, 50, 75, 100];
